import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch, useSelector } from 'react-redux';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import WebapiCommon from '@common/util/webapi.common';
import EditorContainer from '@componentes/editor/editor.container';
import * as editor from '@componentes/editor/editor.util';
import { errors } from '../../../../../../pages/error/erros';
import { useHistory } from 'react-router-dom';
import * as editorActions from '@componentes/editor/editor.action';

export default function ModalCadastroAutoTexto(props) {

  const history = useHistory();
  const [titulo, setTitulo] = useState('');
  const [tituloMensagem, setTituloMensagem] = useState('');
  const [atalho, setAtalho] = useState('');
  const [atalhoMensagem, setAtalhoMensagem] = useState('');
  const [selectGrupos, setSelectGrupos] = useState([]);
  const [grupo, setGrupo] = useState([]);
  const modalAberto = useSelector(state => state.commonReducer.showModal);

  const dispatch = useDispatch();

  const laudo = useSelector(state => state.commonReducer.detalhes.laudo);
  const etapa = useSelector(state => state.commonReducer.etapa.etapa);
  const inicializado = useSelector(state => state.editorComponent.editorCarregado);

  function resetInputs() {
    setTitulo('');
    setAtalho('');
    setGrupo('');
  }

  function carregarEditor() {
    const blank = true;
    try {
      editor.Inicializar(laudo, etapa, dispatch, blank);
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = 'Modal Autotexto';
      const code = 101;

      errors.map(err => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }
  }

  useEffect(() => {
    WebapiCommon.getGrupoExame().then((res) => {
      setSelectGrupos(res);
    }).catch((err) => {
      console.log(err);
    });
  }, [])

  useEffect(() => {
    resetInputs();
    dispatch(editorActions.showEditor(true));
    dispatch(editorActions.editorAltura('325px'));
    if (props.showModal) {
      dispatch(commonActions.showFadeCarregando(true));
      carregarEditor();
      if (inicializado) {
        dispatch(commonActions.showFadeCarregando(false));
      }
    } else {
      dispatch(commonActions.showFadeCarregando(false));
    }
  }, [props.showModal]);


  function toggle() {
    props.onModal(!props.showModal);
  }

  function novoGrupo(val) {
    WebapiCommon.novoGrupoExame(val).then((res) => {
      setSelectGrupos(res);
    }).catch((err) => {
      console.log(err);
    });
  }

  function changeTitulo(val) {
    const maxValue = 45;
    if (val.length > maxValue) {
      return;
    }
    setTitulo(val);
    setTituloMensagem(textLength(val, maxValue));
  }

  function removeEspecialChar(especialChar) {
    let er = /[^a-z0-9_]/gi;
    especialChar = especialChar.replace(/[ÀÁÂÃÄÅ]/g, "A");
    especialChar = especialChar.replace(/[àáâãäå]/g, "a");
    especialChar = especialChar.replace(/[ÈÉÊË]/g, "E");
    especialChar = especialChar.replace(/[éèêë]/g, "é");
    especialChar = especialChar.replace(/[ÌÍÎÏ]/g, "I");
    especialChar = especialChar.replace(/[íìîï]/g, "i");
    especialChar = especialChar.replace(/[ÒÓÔÕÖ]/g, "O");
    especialChar = especialChar.replace(/[òóôõö]/g, "o");
    especialChar = especialChar.replace(/[ÙÚÛÜ]/g, "U");
    especialChar = especialChar.replace(/[úùûü]/g, "u");
    especialChar = especialChar.replace(/[Ç]/g, "C");
    especialChar = especialChar.replace(/[ç]/g, "c");
    especialChar = especialChar.replace(/[ ]/g, "_");
    const texto = especialChar.replace(er, "");
    return texto;
  }

  function changeAtalho(val) {
    val = removeEspecialChar(val);
    const maxValue = 20;
    if (val.length > maxValue) {
      return;
    }
    setAtalho(val);
    setAtalhoMensagem(textLength(val, maxValue));
  }

  function textLength(text, max = 200) {
    if (!text) {
      return
    }
    const carac = max - text.length;
    let msn = `Restam ${carac} caracteres`;

    if (carac === 1) {
      msn = `Resta ${carac} caracter`;
    } else if (carac === 0) {
      msn = `Máximo de caracteres atingido `;
    }

    return msn;
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className="modal-autotext"
          centered
          isOpen={props.showModal}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            Cadastro de Auto Texto {props.tabs === '2' && 'Geral'}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup className={`confirmar-primary`}>
                  <Label>Titulo:</Label>
                  <Input
                    type="text"
                    value={titulo}
                    onChange={(e) => changeTitulo(e.target.value)}
                  />
                  <div className="texto-observacao">{tituloMensagem}</div>
                </FormGroup>
              </Col>
              {props.tabs === '1' && <Col>
                <FormGroup className={`confirmar-primary`}>
                  <Label>Atalho:</Label>
                  <Input
                    type="text"
                    value={atalho}
                    onChange={(e) => changeAtalho(e.target.value)}
                  />
                  <div className="texto-observacao">{atalhoMensagem}</div>
                </FormGroup>
              </Col>}
            </Row>

            {props.tabs === '1' &&
              <Row>
                <Col>
                  <FormGroup className={`confirmar-primary`}>
                    <SelectCreatableComponent
                      type="create"
                      options={selectGrupos}
                      placeholder="Selecione um grupo "
                      defaultValue={grupo}
                      onCreateOption={(e) => novoGrupo(e)}
                      onChange={(e) => setGrupo(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>}

            <EditorContainer history={history} />

          </ModalBody>
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color="secondary"
            >
              Cancelar
            </Button>
            <Button
              className={`button-confirm`}
              onClick={() => {
                props.confirmar({ titulo, atalho, grupo });
              }}
              disabled={
                !titulo || (!atalho && props.tabs === '1') || (!grupo && props.tabs === '1')
              }
              color="primary"
            >
              Cadastrar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/app/common/tabs/autotexto/modal/cadastro/index.js